import {Action, openDialog} from 'platform/components';

import {isNil, isNotNil} from 'ramda';

import {TemplateResponseBody} from '@dms/api/core';
import i18n from '@dms/i18n';

import {buildArray} from 'shared/web';

import {CreateTemplateForm} from '../../TemplateManagement/components/CreateTemplateForm';
import {useDownloadTemplate} from './useDownloadTemplate';

export const useGetDocumentKindActions = () => {
  const [downloadTemplate] = useDownloadTemplate();

  const getActions = (
    templates: Array<TemplateResponseBody & {isPrimary: boolean}>,
    documentKindCode: string,
    documentType: 'docx' | 'html'
  ) => {
    const primaryTemplate = templates.find((template) => template.isPrimary);

    return buildArray<Action>()
      .when(isNotNil(primaryTemplate), {
        type: 'button',
        leftIcon: 'file/download',
        title: i18n.t('entity.document.actions.downloadPrimary'),
        variant: 'link',
        onClick: () => {
          if (isNil(primaryTemplate)) {
            throw new Error("Typecheck error: Primary template doesn't exist");
          }

          downloadTemplate({...primaryTemplate, definitionType: documentType});
        },
      })
      .add({
        type: 'button',
        leftIcon: 'content/add_circle',
        title: i18n.t('general.actions.upload'),
        variant: 'link',
        onClick: () =>
          openDialog(
            <CreateTemplateForm
              authorizationProfileId={null}
              documentCode={documentKindCode}
              documentType={documentType}
            />,
            {
              title: i18n.t('entity.documents.labels.uploadNewTemplateDialogTitle'),
            }
          ),
      });
  };

  return [getActions] as const;
};
